declare var dataLayer;
declare var _satellite;
declare var formtracker;
declare var videoPlayerTracker;

export class AnalyticsService {

	private static instance: AnalyticsService;

	constructor() { }

	static getInstance() {
		if (!AnalyticsService.instance) {
			AnalyticsService.instance = new AnalyticsService();
		}
		return AnalyticsService.instance;
	}

	//
	//
	// GENERIC USER INTERACTION
	//
	//
	dtmGenericUserInteraction(uivalue: string) {
		if (typeof dataLayer != 'undefined') {
			dataLayer.userInteraction = uivalue;
			if (typeof _satellite == 'object') {
				_satellite.track('genericUserInteraction');
			}
		}
	}

	//
	//
	// Records the form feld failure upon submit (i.e. client side)
	//
	//
	dtmFormFieldsValidationFail(fields: string) {
		if (typeof dataLayer != 'undefined') {
			dataLayer.formFieldsErrors = fields;
			dataLayer.siteErrorCode = "client side|user failed on form fields";
			if (typeof _satellite == 'object') {
				_satellite.track('sendSiteErrorCode');
			}
		}
	}

	//
	//
	// Trigger Ajax Form Complete
	// @status -  "complete" or "declined"
	// @leadID - lead id linked to the form complete
	//
	dtmFormComplete(status: string, leadID: string) {
		if (status && (typeof dataLayer != 'undefined')) {
			dataLayer.formStatus = status;
			dataLayer.formisSubmitted = false;
			dataLayer.leadID = leadID;
			if (typeof _satellite == 'object') {
				_satellite.track('globalFormComplete');
			}
		}
	}
	dtmFormStart() {
		if ((typeof dataLayer != 'undefined')) {
			if (typeof _satellite == 'object') {
				_satellite.track('globalFormStart');
			}
		}
	}

	dtmFormNameUpdate(name: string) {
		if (name && (typeof dataLayer != 'undefined')) {
			dataLayer.formName = name;
		}
	}

	dtmFormAbandon() {
		if (typeof _satellite == 'object') {
			_satellite.track("globalFormAbandon");
		}
	}

	//
	//
	// force a form start on inputs that are hidden or being interacted by a slider for example
	// @field - has to be the form element html element
	//
	dtmTriggerFormStart(field: HTMLElement) {
		if (typeof formtracker !== "undefined") {
			formtracker.trigger(field, "change");
		}
	}

	//
	//
	// force a form start on inputs that are hidden or being interacted by a slider for example
	// @field - has to be the form element html element
	//
	dtmRecordSiteError(error: any) {
		if (typeof dataLayer != 'undefined') {
			dataLayer.siteErrorCode = error;
			if (typeof _satellite == 'object') {
				_satellite.track('sendSiteErrorCode');
			}
		}
	}

	//
	//
	// Allow form to be restarted
	// Usually done if a form is being reused
	//
	dtmAllowFormRefresh() {
		if (typeof formtracker !== "undefined") {
			formtracker.refresh();
			formtracker.restartForm();
		}
	}

	//
	//
	// Allow form to be restarted
	// Usually done if a form or calculator needs to be restarted (i.e. allowing users to trigger start upon next interaction)
	//
	dtmRestartForm() {
		if (typeof formtracker !== "undefined") {
			formtracker.restartForm();
		}
	}

	getDtmVisitorID() {
		let visitorId = "";
		if (typeof _satellite == 'object') {
			visitorId = _satellite.getVisitorId().getMarketingCloudVisitorID();
		}
		return visitorId;
	}

	//
	//
	// Allow videoPlayerTracker to detect new created videos
	//
	dtmVideoTrackerAutoSpot() {
		if (typeof videoPlayerTracker !== "undefined") {
			videoPlayerTracker.autoSpotYTVideos();
		}
	}

}



// WEBPACK FOOTER //
// ./services/analytics.service.ts